var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('delivery-form',{attrs:{"title":"به روزرسانی نرخ","submitFunction":_vm.updateDelivery}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }